import React from 'react';
import { formatAuditDateTime } from './utils';

const ChecklistAuditTable = ({ audits = [], checklistLookup = {}, currentUserId, currentUserName }) => {
    if (!audits.length) {
        return <div className="text-[11px] text-[#8992a8] italic py-2">No activities recorded yet.</div>;
    }

    return (
        <div className="overflow-x-auto max-h-60 overflow-y-auto mt-2 border border-[#edf0f6] rounded-md bg-white">
            <table className="w-full text-left text-xs border-collapse">
                <thead className="bg-[#fbfcff] sticky top-0 border-b border-[#edf0f6] z-[1]">
                    <tr className="text-[#8992a8] text-[10px] uppercase font-semibold tracking-wider">
                        <th className="py-2 px-3">Activities</th>
                        <th className="py-2 px-3 w-28">Status</th>
                        <th className="py-2 px-3">User</th>
                        <th className="py-2 px-3 whitespace-nowrap w-44">Date & Time</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-[#edf0f6]">
                    {audits.map((entry, idx) => {
                        const item = checklistLookup[String(entry.checklist_id)];
                        const label = item?.label || item?.name || 'Checklist item';
                        const isChecked = String(entry.status || '').toUpperCase() === 'CHECKED';
                        const isUnchecked = String(entry.status || '').toUpperCase() === 'UNCHECKED';
                        const userName =
                            entry.user_name ||
                            (currentUserId && entry.user_id === currentUserId ? currentUserName : '') ||
                            entry.user_id ||
                            'User';
                        return (
                            <tr key={`${entry.checklist_id}-${entry.date_time || idx}-${idx}`} className="hover:bg-[#fbfcfe] transition-colors">
                                <td className="py-2 px-3 font-medium text-[#334064] text-[11px]">{label}</td>
                                <td className="py-2 px-3">
                                    <span
                                        className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold ${
                                            isChecked
                                                ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                                                : isUnchecked
                                                  ? 'bg-slate-100 text-slate-600 border border-slate-200'
                                                  : 'bg-amber-50 text-amber-700 border border-amber-200'
                                        }`}
                                    >
                                        {isChecked ? '✓ Checked' : isUnchecked ? '✕ Unchecked' : entry.status}
                                    </span>
                                </td>
                                <td className="py-2 px-3 text-[#496577] text-[11px]">{userName}</td>
                                <td className="py-2 px-3 text-[#8992a8] text-[11px] whitespace-nowrap">
                                    {formatAuditDateTime(entry.date_time)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ChecklistAuditTable;

